import { makeStyles, Typography, Grid } from '@material-ui/core';
import React from 'react';
import { COLORS } from '../../../plTheme';

import ReportSalesActivity from '../../atoms/ReportSalesActivity';
import { _t_ } from '../../../utils/translation/translation';
import { driverNameMapping } from '../../organisms/NewLeaderboard/driverConstants';
import CustomTooltip from '../../atoms/CustomTooltip';

interface RepComparisonSalesActivitiesProps {
  headingName: string;
  firstPersonValue: number;
  secondPersonValue: number;
  benchmarkValue: number;
  index: number;
  minValue: number;
  maxValue: number;
}

const RepComparisonSalesActivities: React.FC<RepComparisonSalesActivitiesProps> = ({
  headingName,
  firstPersonValue,
  secondPersonValue,
  benchmarkValue,
  index,
  minValue,
  maxValue,
}: RepComparisonSalesActivitiesProps) => {
  const useStyles = makeStyles({
    root: {
      width: '91%',
      minHeight: '74px',
      alignItems: 'center',
      backgroundColor: COLORS.REPORTPAGE6BACKGROUNDCOLOR,
      border:
        index == 0 ? '1px solid #2E6FF2' : '1px solid rgba(215, 223, 233, 0.2)',
      position: 'relative',
      marginLeft: 50,
      marginRight: 50,
      padding: '6px 0px 6px 12px', // Increased padding for better spacing
      WebkitPrintColorAdjust: 'exact',
      printColorAdjust: 'exact',
    },
    heading: {
      lineHeight: '20px',
      color: COLORS.REPCOMPARISONHEADINGCOLOR,
      width: '265px',
      fontFamily: 'Rubik',
      fontSize: 14,
      fontWeight: 500,
    },
    headingContainer: {
      flex: '0 0 245px', // Fixed width for heading section
    },
    progressBarContainer: {
      flex: '1 1 auto',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      gap: '24px', // Space between progress bars
    },
  });
  const classes = useStyles();

  return (
    <div className={classes.root} style={{ display: 'flex', alignItems: 'center' }}>
      {/* Heading Section */}
      <Grid item xs={4}  className={classes.headingContainer}>
        <Typography 
          variant="h5" 
          className={classes.heading}
          style={{ margin: 0, marginBottom: '2px' }} // Remove default margins
        >
          {driverNameMapping[headingName] || headingName}
          <CustomTooltip text="" driverName={headingName} />
        </Typography>
        <p
          style={{
            fontSize: '12px',
            color: 'rgb(107, 114, 128)',
            margin: '-4px 0px 0px 0px',
            fontFamily: 'Rubik',
            fontWeight: 500,
          }}
        >
          Avg: {benchmarkValue}
        </p>
      </Grid>
      
      {/* Progress Bars Section */}
      <Grid item xs={4}  className={classes.progressBarContainer}>
        <ReportSalesActivity
          value={firstPersonValue}
          benchmarkValue={benchmarkValue}
          minValue={minValue}
          maxValue={maxValue}
        />
      </Grid>
       <Grid item xs={4}  className={classes.progressBarContainer}>
        <ReportSalesActivity
          value={secondPersonValue}
          benchmarkValue={benchmarkValue}
          minValue={minValue}
          maxValue={maxValue}
        />
      </Grid>
    </div>
  );
};

export default RepComparisonSalesActivities;
